/******
 *  store 下的index.js 专门处理 vuex中的模块
 *
 * *****/
import Vue from "vue";
import Vuex from "vuex";
import * as auth from "@/utils/auth";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    user: {
      loginToken: auth.getUser(),
      userId: auth.getUserId()
    },
    photo: null
  },
  mutations: {
    updateUser(state, payload) {
      state.user.loginToken = payload.token;
      console.log('333',state.user.loginToken)
      state.user.userId = payload.userId;
      auth.setUser(payload.token);
      auth.setUserId(payload.userId);
    },
    delUser(state) {
      state.user = {};
      auth.delUser();
      auth.delUserId();
    },
    updatePhoto(state, payload) {
      state.photo = payload.photo;
    }
  },
  actions: {},
  modules: {}
});
